import React from "react";
import { ReactComponent as TruthfulSvg } from "../../assets/icons/truthful.svg";

export default function TruthfulIcon({ size = 20, className = "" }) {
  return (
    <TruthfulSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
